import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { ROUTE_NAMES } from '@bakbak/common';
import { ProfileDetailsController, IProfileDetailsQuery, LogoutController } from "@bakbak/controller";

import { ProfileView } from "./ProfileView";
import { withAppContext, AppContextProps } from "../../../context/AppContext";


export class ProfileC extends React.PureComponent<RouteComponentProps<{}> & IProfileDetailsQuery & AppContextProps> {

  async componentDidMount() {
    const { context, history } = this.props;
    if (!context.loggedUser) {
      history.push(ROUTE_NAMES.LOGIN);
    }
  }

  onLogoutComplete = async () => {
    await this.props.context.updateLoggedUser(null);
    this.props.history.push(ROUTE_NAMES.LOGIN);
  }

  gotoPostDetails = async (postId: string) => {
    this.props.history.push(ROUTE_NAMES.LOGIN);
  }

  editProfile = () => {
    this.props.history.push(ROUTE_NAMES.EDIT_PROFILE);
  }

  updateLoggedUser = (profile: any) => {
    this.props.context.updateLoggedUser(profile);
  }

  render() {
    const { loggedUser } = this.props.context;
    if (!loggedUser) {
      return <div />
    }
    return (
      <ProfileDetailsController userId={loggedUser.id}>
        {(data) => {
          const { profile, profileLoading } = data;
          if (profileLoading || !profile) {
            return <div />;
          }
          return (
            <LogoutController>
              {({ logout }) =>
                <ProfileView
                  profile={profile}
                  logout={logout}
                  onLogoutComplete={this.onLogoutComplete}
                  gotoPostDetails={this.gotoPostDetails}
                  editProfile={this.editProfile}
                  updateLoggedUser={this.updateLoggedUser}
                />
              }
            </LogoutController>
          );
        }}
      </ProfileDetailsController>
    );
  }
}

export const ProfileConnector = withAppContext(ProfileC);



// WEBPACK FOOTER //
// ./src/modules/profile/find/ProfileConnector.tsx